export default "__VITE_ASSET__CQSlWisZ__"